import React from 'react';
import { useAdmin } from '../../../AdminContext';
import AdminLoginForm from './AdminLoginForm';
import AdminDashboard from './AdminDashboard';

const AdminPage: React.FC = () => {
  const { isAdmin } = useAdmin();
  return isAdmin ? <AdminDashboard /> : <AdminLoginForm />;
};

export default AdminPage;
